var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-field',{attrs:{"label":"Selecciona un periodo"}},[_c('b-datepicker',{attrs:{"placeholder":"Click para seleccionar...","range":""},on:{"input":_vm.onFechaSeleccionada},model:{value:(_vm.fechasSeleccionadas),callback:function ($$v) {_vm.fechasSeleccionadas=$$v},expression:"fechasSeleccionadas"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }